"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'regen',
    client_id: '07-tendermint-31',
    connection_id: 'connection-29'
  },
  chain_2: {
    chain_name: 'sentinel',
    client_id: '07-tendermint-56',
    connection_id: 'connection-32'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-15',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-11',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {}
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'regen',
    client_id: '07-tendermint-73',
    connection_id: 'connection-60'
  },
  chain_2: {
    chain_name: 'sifchain',
    client_id: '07-tendermint-31',
    connection_id: 'connection-13'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-28',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-10',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {}
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'regen',
    client_id: '07-tendermint-74',
    connection_id: 'connection-61'
  },
  chain_2: {
    chain_name: 'starname',
    client_id: '07-tendermint-45',
    connection_id: 'connection-31'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-29',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-14',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {}
  }]
}];
var _default = exports["default"] = info;